import React from 'react';

import SvgContainer from '../SvgContainer';

const ArrowRight = () => {
    return (
        <SvgContainer>
            <path d="M3.80279 2.18735C3.36724 1.77662 3.36724 1.08399 3.80279 0.673251C4.20367 0.295209 4.82975 0.295209 5.23063 0.673251L12.2285 7.27247C12.6471 7.66719 12.6471 8.33281 12.2285 8.72753L5.23063 15.3267C4.82975 15.7048 4.20367 15.7048 3.80279 15.3267C3.36724 14.916 3.36724 14.2234 3.80279 13.8126L9.96658 8L3.80279 2.18735Z" />
        </SvgContainer>
    );
};

export default ArrowRight;
